// @ts-check
/**
 * Master feature toggles driven by environment variables.
 * All flags default to ON so the store works out of the box in development.
 * Set REACT_APP_ENABLE_SHOP=false in production env until ready to launch.
 *
 * NOTE: There is NO standalone /shop page. Product browsing is merged into
 * the /books page (Books.jsx). ENABLE_SHOP controls cart, checkout, quotes,
 * and bundle/product detail routes under /books/*.
 */
const featureFlags = {
  /** When false, /cart, /checkout, /quote and detail routes return 404. */
  ENABLE_SHOP: process.env.REACT_APP_ENABLE_SHOP !== 'false',

  /** When false, educator verification CTA links to a "coming soon" notice. */
  ENABLE_EDUCATOR_VERIFICATION: process.env.REACT_APP_ENABLE_EDUCATOR_VERIFICATION !== 'false',

  /**
   * 'placeholder' — dev-safe mode, no Stripe credentials needed (order marked paid directly).
   * 'stripe' — production mode, redirects to Stripe Checkout hosted page.
   * Future: 'tabby' | 'paypal' can be added as additional values.
   */
  PAYMENT_PROVIDER: process.env.REACT_APP_PAYMENT_PROVIDER || 'placeholder',

  /** When false, currency switcher is hidden and all prices display in AED. */
  ENABLE_MULTI_CURRENCY: process.env.REACT_APP_ENABLE_MULTI_CURRENCY !== 'false',
};

export default featureFlags;
